export default "__VITE_ASSET__baa016c9__"